import React, { FC, useState } from "react"
import { Button } from "ui-kit-sber/dist/js/components/Button"
import styled from "styled-components"
import Calc from "npfsb-corporate-calc"
import arrowDownIcon from "../../../static/icons/arrow-down.svg"
import { Accordion } from "react-bootstrap"

const BlockStyle = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding: 80px 20px;

  @media screen and (max-width: 1023px) {
    padding: 40px 69px;
  }

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }

  p {
    font-size: 16px;
    line-height: 24px;
  }

  .accordion {    
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    justify-content: flex-end;

    p {
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      color: #878b90;
    }

    @media screen and (max-width: 1024px) {
      flex-direction: column;
    }

    button {
      padding: 0;
      align-items: center;
      justify-content: center;
      position: relative;
      right: -11px;
      border-radius: 50%;
      display: inline-flex;
      width: 20px;
      height: 20px;
      background: #f3f3f3;
      cursor: pointer;

      @media screen and (max-width: 1024px) {
        right: 0;
      }

      @media screen and (max-width: 768px) {
        margin-bottom: 7px;
      }

      &::before {
        content: url("${arrowDownIcon}");
        position: relative;
        // safari and chrome proceed relative position
        // of element which sizes are not set differently
        bottom: 10px;
        height: 10px;
        display: block;
      }
    }

    .collapsed {
      &::before {
        transform: rotate(-180deg);
        bottom: -12px;
        height: 10px;
      }
    }
  }
`

const CalculatorWrapper = styled.div`
  margin: 39px 0;
  margin-bottom: 15px;
  box-sizing: border-box;
  /* position: relative; */

  @media screen and (min-width: 769px) {
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    border: 1px solid #f0f3f6;
  }

  b {
    font-size: 12px;
    line-height: 20px;
    color: rgb(133, 135, 138);
    white-space: nowrap;
    font-weight: 600;
  }

  #kppBudget {
    /* display: none; */
  }

  #economy div:last-child {
    color: #21a038 !important;
    white-space: nowrap;
  }

  .custom {
    border-radius: 4px;
    &:hover {
      color: white;
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 20px;
      display: inline-block;
      margin-top: -20px;
    }

    @media screen and (max-width: 467px) {
      display: block;
      text-align: center;
    }

    @media screen and (max-width: 320px) {
      font-size: 14px;
    }
  }

  //override calc styles
  .calculator__button {
    /* display: none; */
  }

  .kpp-calculator {
    &__data {
      @media screen and (max-width: 768px) {
        padding: 0;
      }
    }

    &__input {
      border-radius: 4px;
      font-size: 16px;
      line-height: 20px;
      color: #333f48;

      &-title {
        @media screen and (max-width: 1100px) {
          font-size: 14px;
        }
      }

      &-group input {
        font-weight: 600;
      }

      & + div {
        margin: 3px 0 16px;
        margin-top: 3px;
        font-size: 12px;
      }
    }

    &__field-group {
      margin-top: 22px;
    }

    &__sum {
      padding: 0;

      div:first-child {
        margin-top: -4px;
        color: #21a038;
        max-width: 100%;
        font-family: "SB Sans Display";

        @media screen and (max-width: 768px) {
          font-size: 38px;
        }
      }

      div:last-child {
        bottom: 27px;
        right: -49px;
        font-size: 60px;
        color: #21a038;

        @media screen and (max-width: 768px) {
          bottom: 19px;
          right: -34px;
          font-size: 38px;
        }
      }
    }

    &__total {
      color: #333f48;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;

      @media screen and (max-width: 768px) {
        margin-top: 32px;
      }
    }

    &__budget {
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      margin-top: 59px;

      @media screen and (max-width: 768px) {
        margin-top: 24px;
      }
    }

    &__subsum-result {
      font-family: "SB Sans Display";
      white-space: nowrap;
      & > div {
        right: 4px;
        font-size: 34px;
        bottom: 7px;
        font-weight: normal;
      }
    }
  }
`

const DisclaimerStyle = styled.ol`
  list-style: decimal;
  margin-left: 20px;
  margin-top: 10px;

  li {
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    color: #878b90;
  }
`

const disclaimerList: string[] = [
  'Не является офертой. В расчетах применяются действующие тарифы страховых взносов по ОПС, ОСС, ОМС, а также предельная величина базы по страховым взносам на ОПС 1,292 млн руб., по взносам на ОСС на случай временной нетрудоспособности и в связи с материнством – 912 тыс. руб. согласно постановлению Правительства РФ от 6 ноября 2019 г. № 1407 "О предельной величине базы для исчисления страховых взносов на обязательное социальное страхование на случай временной нетрудоспособности и в связи с материнством и на обязательное пенсионное страхование с 1 января 2020 г.; ОПС – обязательное пенсионное страхование, ОСС – обязательное социальное страхование, ОМС – обязательное медицинское страхование.',
  "Суммы пенсионных взносов, уплачиваемых вкладчиком в пользу своих работников (участников) в НПФ по договору негосударственного пенсионного обеспечения, не облагаются страховыми взносами на основании подпункта 5 пункта 1 статьи 422 НК РФ.",
  'Суммы платежей работодателей по договорам НПО, заключенным в пользу работников включаются в расходы на оплату труда. Они учитываются при расчете налога на прибыль в соответствии с п. 16 ст. 255 НК РФ. при выполнении следующих условий: в соответствии с договором НПО применяется пенсионная схема, предусматривающая учет пенсионных взносов на именных счетах участников НПФ; договоры НПО должны предполагать выплату пенсий до исчерпания средств на именном счете участника, но в течение не менее пяти лет или пожизненно. Данные расходы нормируются. Учесть можно совокупную сумму платежей, уплачиваемых в соответствии с Федеральным законом "О дополнительных страховых взносах на накопительную пенсию и государственной поддержке формирования пенсионных накоплений", и взносов работодателей, по договорам долгосрочного страхования жизни работников, добровольного пенсионного страхования и (или) негосударственного пенсионного обеспечения работников в размере, не превышающем 12% от суммы расходов на оплату труда.',
  "Суммы пенсионных взносов по договорам НПО, уплаченные вкладчиком в пользу работников (участников) в НПФ, в порядке и на условиях, установленных Федеральным законом N 75-ФЗ, в соответствии с п. 1 ст. 213.1 НК РФ не подлежат обложению налогом на доходы физических лиц.",
]

const Calculator: FC = () => {
  const [calculatorValues, setCalculatorValues] = useState({})
  const [collapseState, setCollapseState] = useState<string>("")

  const toggleCollapseState = () => {
    setCollapseState(prevState => {
      if (!prevState) {
        return "collapsed"
      } else {
        return ""
      }
    })
  }

  const customResultButton = {
    onClick: () => {
      window.open("https://npfsberbanka.ru/business/#kpp-questions-section")
    },
    text: "Подберите свою программу",
    classWrapper: "calculator__button custom",
  }

  return (
    <BlockStyle>
      <h2>Еще не подключили КПП?</h2>
      <CalculatorWrapper>
        <Calc
          getValues={setCalculatorValues}
          anchor="request"
          isPaymentDisabled
          isLanding={false}
          antikrizis={false}
          showButton={true}
          customResultButton={customResultButton}
        />
      </CalculatorWrapper>
      <Accordion>
        <Accordion.Toggle
          eventKey="0"
          className={collapseState}
          onClick={toggleCollapseState}
        />
        <p>
          Калькулятор позволяет произвести предварительный расчет экономии для
          вашего бизнеса от внедрения корпоративной пенсионной программы
        </p>
        <Accordion.Collapse eventKey="0">
          <DisclaimerStyle>
            {disclaimerList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </DisclaimerStyle>
        </Accordion.Collapse>
      </Accordion>
    </BlockStyle>
  )
}

export default Calculator
